import { useSelector } from "react-redux";
import _ from "lodash";

export default function useTableState(table) {
  return useSelector((state) => {
    return JSON.parse(_.get(state.admin.tablesStates, table) || "{}");
  });
}
